__turbopack_context__.v({
  "container": "xJr_sW_container",
  "floatingHeader": "xJr_sW_floatingHeader",
  "hasSelectedVariant": "xJr_sW_hasSelectedVariant",
  "imageContainer": "xJr_sW_imageContainer",
  "metaContainer": "xJr_sW_metaContainer",
  "priceAddition": "xJr_sW_priceAddition",
  "pricingContainer": "xJr_sW_pricingContainer",
  "productPlaceholderImage": "xJr_sW_productPlaceholderImage",
  "show": "xJr_sW_show",
});
